<template>
  <div class="mb-3 text-center">
    <div class="box-image position-relative d-inline-block image-wrapper">

      <img
        v-if="currentImage"
        :src="currentImage.path"
        class="img-fluid"
        style="max-width: 300px;"
        alt="Imagen producto"
      >

      <!-- Botón izquierda -->
      <button
        v-if="filteredImage.length > 1"
        class="btn btn-dark position-absolute top-50 start-0 translate-middle-y"
        @click="prevImage"
      >
        ‹
      </button>

      <!-- Botón derecha -->
      <button
        v-if="filteredImage.length > 1"
        class="btn btn-dark position-absolute top-50 end-0 translate-middle-y"
        @click="nextImage"
      >
        ›
      </button>

    </div>
  </div>

</template>

<script>
export default {
  props: {
    filteredImage: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      currentIndex: 0
    }
  },

  computed: {
    currentImage() {
      return this.filteredImage[this.currentIndex] || null
    }
  },

  methods: {
    nextImage() {
      this.currentIndex =
        (this.currentIndex + 1) % this.filteredImage.length
    },

    prevImage() {
      this.currentIndex =
        (this.currentIndex - 1 + this.filteredImage.length) %
        this.filteredImage.length
    }
  },

  watch: {
    filteredImage() {
      this.currentIndex = 0
    }
  }
}

</script>

<style scoped>
.image-wrapper {
  width: 300px;
  height: 300px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* o cover */
}

</style>